import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=475af21d&scoped=true"
import script from "./Award.vue?vue&type=script&lang=js"
export * from "./Award.vue?vue&type=script&lang=js"
import style0 from "./Award.vue?vue&type=style&index=0&id=475af21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475af21d",
  null
  
)

export default component.exports